import React from 'react';
import { useField } from 'formik';
import { Q1Value } from 'models/documents';
import DatePicker from 'components/Input/datepicker/Datepicker';
import utils from 'utils';
import { DataGridRow } from 'components/DataGrid';
import { BoundingBox } from 'models/response';

export interface CellDatePicker {
  name: string;
  focus: boolean;
  onFocus: (cell?: { pageNumber: number; boundingBox: BoundingBox; content: string }) => void;
  row: DataGridRow;
  code: number;
  dateFormat?: string;
  disabled?: boolean;
}

const CellDatePicker = (props: CellDatePicker) => {
  const { row, code, name, focus, dateFormat, onFocus, disabled } = props;
  const [field, , helpers] = useField<Q1Value>(name);

  const convertSelectedDate = (date: string) => {
    const dateConvertedReverse = utils.date.convertDateReverse(date);
    if (dateConvertedReverse) {
      const dateConverted = new Date(dateConvertedReverse);
      if (utils.date.isValidDate(dateConverted)) return dateConverted;
    }
  };

  // Formatting and updating the rows state on inputs change
  const onFieldChange = (value: string, rowId: string, fieldId: string | number) => {
    const body: DataGridRow[] | undefined = field.value.body?.map((elem: DataGridRow) => {
      if (elem.id === rowId) {
        return {
          ...elem,
          [fieldId]: {
            content: value,
            pageNumber: -1,
            boundingBox: {
              x1: -1,
              y1: -1,
              x2: -1,
              y2: -1,
            },
          },
        };
      }
      return elem;
    });
    if (body) helpers.setValue({ ...field.value, body });
  };

  let selectedDate;
  const fieldDate = field.value.body?.find(({ id }) => id === row.id);
  if (fieldDate) {
    if (fieldDate[code]?.content) {
      selectedDate = convertSelectedDate(fieldDate[code].content);
    }
  }

  return (
    <DatePicker
      inputWidth="100%"
      selected={selectedDate}
      focus={focus}
      onFocus={() => onFocus(fieldDate ? fieldDate[code] : null)}
      portal
      dateFormat={dateFormat}
      onChange={(date: Date | null) => {
        if (date !== null) {
          const value = utils.date.formatDateForDb(date);
          onFieldChange(value, row.id, code);
        } else {
          onFieldChange('', row.id, code);
        }
      }}
      noBorder={true}
      disabled={disabled}
    />
  );
};

export default CellDatePicker;
